var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#192949",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93429 4.0657C3.73903 4.26096 3.73903 4.57754 3.93429 4.7728L9.16203 10.0005L3.93485 15.2277C3.73959 15.423 3.73959 15.7396 3.93485 15.9348C4.13011 16.1301 4.44669 16.1301 4.64196 15.9348L9.86914 10.7077L15.248 16.0865C15.4433 16.2818 15.7598 16.2818 15.9551 16.0865C16.1504 15.8913 16.1504 15.5747 15.9551 15.3794L10.5762 10.0005L15.9557 4.62113C16.1509 4.42586 16.1509 4.10928 15.9557 3.91402C15.7604 3.71876 15.4438 3.71876 15.2486 3.91402L9.86914 9.29344L4.64139 4.0657C4.44613 3.87043 4.12955 3.87044 3.93429 4.0657Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.51cefdbfbc5e04faf0ddccd67edcb07e.svg";
export { ForwardRef as ReactComponent };